import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ExportType, InvoiceProcessingService} from '~/app/core/services/invoice-processing.service';
import {InvoiceException} from '@model/InvoiceException';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {UserService} from '~/app/core/services/user.service';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {HomeOffice} from '@model/HomeOffice';
import {GLCodeInvProcessing} from '@model/GLCodeInvProcessing';
import {GLUpdate} from '@model/GLUpdate';
import {ExportDate} from '@model/ExportDate';
import {ChainInvoice} from '@model/ChainInvoice';
import {ExportDialogComponent} from '~/app/web/export-dialog/export-dialog.component';
import {DatePipe} from '@angular/common';
import {paths} from '~/app/app-paths';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-items-posting',
  templateUrl: './items-posting.component.html',
  styleUrls: ['./items-posting.component.scss']
})
export class ItemsPostingComponent implements OnInit {

  public invoiceExceptionList: InvoiceException[] = [];
  public gridDataExceptions: any = [];
  public gridDataExceptionsNoDupes: any = [];
  public gridDateGLCodes: any = [];
  public mySelection: InvoiceException[] = [];
  public mySelectionGLCodes: GLCodeInvProcessing[] = [];
  public selectedCallback = (args) => args.dataItem;
  public selectedCallbackGLCodes = (args) => args.dataItem;
  public selectedHomeOffice: HomeOffice;
  public glCodes: GLCodeInvProcessing[] = [];
  public chnInvList: ChainInvoice[] = [];

  public glUpdate: GLUpdate[] = [];

  constructor(public router: Router,
              public invoiceProcessingService: InvoiceProcessingService,
              public dialogService: FSInvoiceDialogService,
              public userService: UserService,
              public localStorage: LocalStorageIndexedService,
              public datepipe: DatePipe,
              public loadingIndicator: LoadingIndicatorHelper) {
  }

  async ngOnInit() {
    this.loadingIndicator.show();
    if (this.invoiceProcessingService.selectedInvoices) {
      if (this.userService.selectedHomeOffice === undefined) {
        if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
          this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
          await this.init().then(() => {
            this.loadingIndicator.hide();
          });

        } else {
          this.loadingIndicator.hide();
          await this.router.navigate([paths.home]);
        }
      } else {
        this.selectedHomeOffice = this.userService.selectedHomeOffice;
        await this.init().then(() => {
          this.loadingIndicator.hide();
        });
      }
    } else {
      this.loadingIndicator.hide();
      await this.router.navigate([paths.accountspayable]);
    }
  }

  removeDuplicates(myArr: InvoiceException[], prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  public async init() {
    this.invoiceExceptionList = await this.invoiceProcessingService.getExcpetions(this.invoiceProcessingService.selectedInvoices);
    this.gridDataExceptions = this.invoiceExceptionList;
    this.gridDataExceptionsNoDupes = this.removeDuplicates(this.gridDataExceptions, 'invoiceNumber');
    this.glCodes = await this.invoiceProcessingService.getGLCodes();
    this.gridDateGLCodes = this.glCodes;
  }

  postGLClicked() {
    if (this.mySelection.length > 0 && this.mySelectionGLCodes.length > 0) {
      this.loadingIndicator.show();
      this.mySelection.forEach(exception => {
        const gl = new GLUpdate();
        gl.hoId = exception.hoId;
        gl.chn = exception.chn;
        gl.div = exception.divId;
        gl.itemNum = exception.itemNum;
        this.mySelectionGLCodes.forEach(e => {
          gl.glCode = e.code;
        });
        this.glUpdate.push(gl);

      });

      this.invoiceProcessingService.updateGL(this.glUpdate)
        .subscribe(() => {
          console.log('updateGL api called');
          this.init().then(() => {
            this.mySelection = [];
            this.mySelectionGLCodes = [];
            this.loadingIndicator.hide();
          });
        });
    } else {
      this.dialogService.openDialog({
        type: DialogType.ERROR,
        title: 'Post GL',
        content: 'Please Select an Item and GL Code before Posting GL.',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      });
    }
  }


  exportClicked() {
    this.loadingIndicator.show();
    console.log(this.invoiceExceptionList.length);
    if (this.invoiceExceptionList.length > 0) {
      this.showExportDialog();
    } else {
      this.exportDate();
    }
    this.loadingIndicator.hide();
  }

  public showExportDialog() {
    this.dialogService.openDialog({
      type: DialogType.WARNING,
      title: 'Export',
      content: 'There are still items posting to default. Would you like to export now?',
      actions: [
        {text: 'No', primary: false},
        {text: 'Yes', primary: true},
      ],
      width: 400
    }).then(answer => {
      if (answer === 'Yes') {
        this.exportDate();
      } else {
        // no was clicked, do nothing?
      }
    });
  }

  public exportDate() {

    this.loadingIndicator.show();
    // this.invoiceProcessingService.selectedInvoices = '';
    //
    // this.gridDataExceptions.forEach(exception => {
    //   const chainInv = new ChainInvoice();
    //   chainInv.chain = exception.chn;
    //   chainInv.invDate = this.datepipe.transform(exception.invoiceDate, 'yyyy-MM-dd');
    //   chainInv.invNum = exception.invoiceNumber;
    //   this.chnInvList.push(chainInv);
    //   this.invoiceProcessingService.selectedInvoices += this.datepipe.transform(exception.invoiceDate, 'yyyy-MM-dd') + '%20' + exception.invoiceNumber + '%2C';
    // });
    // this.invoiceProcessingService.selectedInvoices = this.invoiceProcessingService.selectedInvoices.slice(0, -3);
    const dialogRef = this.dialogService.open({
      type: DialogType.INFO,
      title: 'Available Exports',
      content: ExportDialogComponent,
      actions: [
        {text: 'Cancel', primary: false},
        {text: 'Download', primary: true},
      ],
      width: 400
    });

    const dialogContent = dialogRef.content.instance;
    dialogRef.result.subscribe((answer: any) => {
      if (answer.text === 'Download') {
        let results = dialogContent.formGroup.value;
        Object.keys(results).forEach(key => {
          if (key === ExportType.APCLARUS && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.APSUMM4);
          }
          if (key === ExportType.APHDR4 && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.APHDR4);
          }
          if (key === ExportType.APHDRDYN && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.APHDRDYN);
          }
          if (key === ExportType.APSUMM4 && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.APSUMM4);
          }
          if (key === ExportType.MASXPORT && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.MASXPORT);
          }
          if (key === ExportType.MSISETUP && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.MSISETUP);
          }
          if (key === ExportType.QBOOKSINVC && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.QBOOKSINVC);
          }
          if (key === ExportType.VOUCHER && results[key] === true) {
            this.invoiceProcessingService.showExportDownload(ExportType.VOUCHER);
          }
        });

        const exportDate = new ExportDate();
        exportDate.hoId = this.invoiceProcessingService.selectedHomeOffice.hoId;
        exportDate.chnInvList = this.invoiceProcessingService.chnInvList;
        this.invoiceProcessingService.exportDate(exportDate)
          .subscribe(() => {
            this.init().then(() => {
              this.loadingIndicator.hide();
            });
          });
      } else {
        this.loadingIndicator.hide();
      }
    });
  }

  backClicked() {
    this.router.navigate([paths.accountspayable]).then(r => r);
  }
}
